import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


/**
 * * Componente pequeno de Paginação do Apolo.
 */
@Component({
  selector: 'ui-small-pagination',
  templateUrl: './small-pagination.component.html',
  styleUrls: ['./small-pagination.component.scss']
})
export class SmallPaginationComponent implements OnInit {

  /**
   * * Opções de tamanhos disponíveis
   */
  @Input() options: number[] = [10, 20, 50, 100, 200]; 
  /**
   * * Tamanho dos Resultados exibidos.
   */
  @Input() size: number = 10; 

  /**
   * * Evento ao trocar de opção de Tamanhos.
   */
  @Output() sizeEmitter = new EventEmitter<number>();

  /**
   * * Exibir Paginação
   */
  @Input() isPaginado: boolean = true;
  /**
   * * Total de resultados da pesquisa.
   */
  @Input() totalSize: number = 1; // 
  /**
   * * Página Atual.
   */
  public currentPage: number = 0;

  /**
   * * Evento de troca de página.
   */
  @Output() pageEmitter = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {}

  public emitSize(event: any) {
    this.size = event.target.value;
    this.sizeEmitter.emit(this.size);
  }

  public emitPage() { this.pageEmitter.emit(this.currentPage); }

  get disableNext(): boolean { return this.currentPage + 1 === this.totalPages; }
  get totalPages(): number { return Math.ceil( this.totalSize / this.size ); }
}
